module.exports = __webpack_public_path__ + "static/Computer-12a744a280152d3320ac820f4b3ee708.svg";